module.exports = __webpack_public_path__ + "img/4_162.e5481486.png";